<template>
  <div id="lokasi-pegawai">
    <b-card>
      <b-row class="mb-2">
        <b-col md="10">
          <h3>{{ $route.name }}</h3>
          <b-breadcrumb>
            <b-breadcrumb-item
              ><router-link to="/dashboard/">{{ $t('dashboard') }}</router-link></b-breadcrumb-item
            >
            <b-breadcrumb-item active>{{ $route.name }}</b-breadcrumb-item>
          </b-breadcrumb>
        </b-col>
        <b-col md="2 mt-4"> </b-col>
      </b-row>
      <b-row class="mt-4 mb-5">
        <b-col cols="12">
          <GmapMap
            :center="center"
            :zoom="18"
            map-style-id="roadmap"
            style="width: 100%; height: 80vmin"
            ref="mapRef"
          >
            <GmapMarker
              :key="index"
              v-for="(loc, index) in locations"
              :position="loc"
              :clickabble="true"
              :draggable="false"
              @click="toggleInfoWindow(loc, loc.uuid)"
              :icon="loc.icon"
              :scaled-size="24"
              :map="Map"
            >
              <!-- @mouseout="showByIndex = true" -->
              <!-- @mouseover="showByIndex = true" -->
              <gmap-info-window :opened="infoWinOpen && currentMidx === loc.uuid">
                <b-link class="text-bold" @click="markerClick(loc)">{{ loc.label }}</b-link>
              </gmap-info-window>
            </GmapMarker>
          </GmapMap>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <label for="" class="labels">daftar pegawai yang berada di lokasi</label>
          <table class="table table-responsive">
            <thead>
              <tr>
                <th>Nama Pegawai</th>
                <th>Terakhir diupdate</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(loc, i) in locations" :key="i">
                <td>{{ loc.label }}</td>
                <td>{{ getDate(loc.time) }}</td>
              </tr>
            </tbody>
          </table>
        </b-col>
      </b-row>
    </b-card>
    <b-modal
      v-model="show"
      size="lg"
      style="width: 90%;"
      id="modalPopover"
      :title="'Riwayat lokasi ' + nameClick"
      ok-only
    >
      <b-row class="mb-5">
        <b-col>
          <label class="labels">Nama Pegawai</label>
          <p class="text-medium">{{ lastData.name }}</p>
          <label class="labels">Terakhir diupdate</label>
          <p class="text-medium">{{ getDate(lastData.time) }}</p>
        </b-col>
        <!-- <b-col style="height: 200px; overflow-y: auto;">
          <label class="labels">Riwayat update</label>
          <div v-for="(det, i) in detail" :key="i" style="overflow-y: auto;">
            <p>
              {{ getDate(det.time) }}
            </p>
          </div>
        </b-col> -->
      </b-row>
      <!-- <p class="text-bold">Semua lokasi</p> -->
      <!-- <GmapMap
        :center="detailCenter"
        :zoom="18"
        map-style-id="roadmap"
        style="width: 100%; height: 70vmin"
        ref="mapRef"
      > -->
      <!-- <GmapMarker
          :key="index"
          v-for="(loc, index) in detail"
          :position="loc"
          :clickabble="true"
          :draggable="true"
        > -->
      <!-- @mouseover="showByIndex = true" -->
      <!-- @mouseout="showByIndex = true" -->
      <!-- @click="markerClick(loc)" -->
      <!-- <gmap-info-window :opened="true">
            <p class="text-bold">{{ getDate(loc.time) }}</p>
          </gmap-info-window>
        </GmapMarker>
      </GmapMap> -->
    </b-modal>
  </div>
</template>

<script>
import Vue from 'vue';
import VueGeolocation from 'vue-browser-geolocation';
import {gmapApi} from 'vue2-google-maps'
Vue.use(VueGeolocation);
export default {
  data() {
    return {
      show: false,
      indexLocation: false,
      nameClick: '',
      infoWinOpen: false,
      currentMidx: null,
      trackingData: [],
      markerColor: '',
      detailCenter: {},
      detail: [],
      lastData: {
        name: '',
        time: '',
      },
      apiUrl: {
        location: window.AppConfig.apiUrl + 'user-last-location',
        tracking: window.AppConfig.apiUrl + 'background-tracking',
      },
      center: {
        lat: 0,
        lng: 0,
        label: 'Master',
      },
      locations: [],
      model: {
        data: [],
        positionOut: '',
        lastLocation: [],
      },
    };
  },
  mounted() {
    this.getLocation();
  },
  computed: {
    google: gmapApi,
  },
  methods: {
    async getLocation() {
      const req = await this.$http.get(this.apiUrl.location);
      req.data.forEach((loc) => {
        if (loc.lastLocation !== null) {
          this.randomMarkerColor();
          this.locations.push({
            lat: loc.lastLocation.latitude,
            lng: loc.lastLocation.longitude,
            label: loc.firstName + ' ' + loc.lastName,
            uuid: loc.uuid,
            initial: loc.firstName.substring(0, 1),
            time: loc.lastLocation.created_at,
            icon: {
              url: `http://maps.google.com/mapfiles/ms/icons/${this.markerColor}`,
              scaledSize: this.google && new google.maps.Size(50, 50),
            },
          });
          this.center = {
            lat: loc.lastLocation.latitude,
            lng: loc.lastLocation.longitude,
          };
        }
      });
    },

    toggleInfoWindow: function(marker, idx) {
      this.infoWindowPos = marker.position;
      this.currentMidx = marker.uuid;
      // this.infoOptions.content = marker.infoText;

      //check if its the same marker that was selected if yes toggle
      if (this.currentMidx === idx) {
        this.infoWinOpen = !this.infoWinOpen;
      }
      //if different marker set infowindow to open and reset current marker index
      else {
        this.infoWinOpen = true;
        this.currentMidx = idx;
      }
    },

    randomMarkerColor() {
      Array.prototype.random = function(length) {
        return this[Math.floor(Math.random() * length)];
      };
      const colores = ['green-dot.png', 'blue-dot.png', 'red-dot.png', 'purple-dot.png'];
      let marker = colores.random(colores.length);
      this.markerColor = marker;
    },

    markerClick(loc) {
      if (loc !== undefined) {
        this.show = true;
        this.nameClick = loc.label;
        this.$http.get(this.apiUrl.tracking + '?user_profile=' + loc.uuid).then((resp) => {
          this.trackingData = resp.data._embedded?.background_tracking;
          this.lastData.name =
            this.trackingData[0].userProfile?.firstName +
            ' ' +
            this.trackingData[0].userProfile?.lastName;
          this.lastData.time = this.trackingData[0].createdAt;
          this.trackingData.forEach((data) => {
            this.detailCenter = {
              lat: data.latitude,
              lng: data.longitude,
              name: data.userProfile.firstName + ' ' + data.userProfile?.lastName,
              time: data.createdAt,
            };
            this.detail.push({
              lat: data.latitude,
              lng: data.longitude,
              time: data.createdAt,
              name: data.userProfile.firstName,
            });
            // this.detail.sort((a, b) => {return a-b})
          });
        });
      }
    },

    getDate(value) {
      if (value !== null) {
        return this.$moment(value).format('DD MMMM YYYY, hh:mm A');
      }
    },
  },
};
</script>

<style lang="css"></style>
